<template>
    <div class="step">
        <div class="content" ref="content">
            <img v-show="index === 1" src="../../assets/img/step/step_1.png">
            <img v-show="index === 2" src="../../assets/img/step/step_2.png">
            <img v-show="index === 3" src="../../assets/img/step/step_3.png">
            <img v-show="index === 4" src="../../assets/img/step/step_4.png">
            <img v-show="index === 5" src="../../assets/img/step/step_5.png">
            <div class="buttons" :class="{white: index > 3}">
                <div class="button left" v-show="index !== 1" @click="index--">上一步</div>
                <div class="button right" v-show="index !== 5"  @click="index++">下一步</div>
                <div class="button right" v-show="index === 5" @click="start">開始使用</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'StepByStep',
        data() {
            return {
                index: 1,
                startX: 0,
                startY: 0,
            }
        },
        methods: {
            start() {
                localStorage.setItem('step-done', 'done');
                this.$emit('onStart', 'done');
            },
            touchStart(el) {
                if ('ontouchstart' in window) {
                    this.startX = el.touches[0].pageX;
                    this.startY = el.touches[0].pageY;
                } else {
                    this.startX = el.pageX;
                    this.startY = el.pageY;
                }
            },
            touchEnd(el) {
                let endX = 0;
                let endY = 0;
                if ('ontouchstart' in window) {
                    endX = el.changedTouches[0].pageX;
                    endY = el.changedTouches[0].pageY;
                } else {
                    endX  = el.pageX;
                    endY = el.pageY;
                }

                let direction = this.GetSlideDirection(this.startX, this.startY, endX, endY);

                if (direction === 'swiperight') {
                    this.index = Math.max(this.index - 1, 1);
                }

                if (direction === 'swipeleft') {
                    this.index = Math.min(this.index + 1, 6);
                    if (this.index >= 6) {
                        this.start();
                    }
                }

                this.startX = 0;
                this.startY = 0;
            },
            GetSlideDirection(startX, startY, endX, endY) {
                let dy = startY - endY;
                let dx = endX - startX;
                let result = 0;

                if (Math.abs(dx) < 2 && Math.abs(dy) < 2) {
                    return result;
                }

                let angle =Math.atan2(dy, dx) * 180 / Math.PI;
                if (angle >= -45 && angle < 45) {
                    result = 'swiperight';
                }
                else if ((angle >= 135 && angle <= 180) || (angle >= -180 && angle < -135)) {
                    result = 'swipeleft';
                }

                return result;
            }
        },
        mounted() {
            if ('ontouchstart' in window) {
                this.$refs.content.addEventListener('touchstart', this.touchStart);
                this.$refs.content.addEventListener('touchend', this.touchEnd);
            } else {
                this.$refs.content.addEventListener('mousedown', this.touchStart);
                this.$refs.content.addEventListener('mouseup', this.touchEnd);
            }
        },
        beforeDestroy() {
            if ('ontouchstart' in window) {
                this.$refs.content.removeEventListener('touchstart', this.touchStart);
                this.$refs.content.removeEventListener('touchend', this.touchEnd);
            } else {
                this.$refs.content.removeEventListener('mousedown', this.touchStart);
                this.$refs.content.removeEventListener('mouseup', this.touchEnd);
            }
        }
    };
</script>

<style lang="scss" scoped>
    .step {
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        position: fixed;
        background-color: rgba(0, 0, 0, .5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 999;

        .content {
            position: relative;
            height: 100%;

            & img {
                height: 100%;
                max-height: 100%;
                max-width: 100%;
                user-select:none;
                pointer-events: none;
            }

            .buttons {
                color: #44cc98;
                position: absolute;
                left: 0;
                right: 0;
                bottom: 3%;
                top: 97%;

                .button {
                    position: absolute;
                    bottom: 10%;
                    cursor: pointer;
                    padding: 5px 40px;
                    font-weight: 900;
                    user-select: none;

                    &.left {
                        left: 0;
                    }

                    &.right {
                        right: 0;
                    }
                }

                &.white {
                    color: white;
                }
            }
        }
    }
</style>
